import { ErrorResponse, useNavigate, useRouteError } from "react-router-dom";
import { StyledErrorPage } from "./error-page.styled";
import axios, { AxiosError } from "axios";
import { useEffect, useState } from "react";
import { useAuth } from "../../utils/AuthContext";
// import { useAuth } from "../../utils/AuthContext";
import { toast } from 'react-toastify';


function ErrorPage() {

  const { logoutUser } = useAuth();
  const navigate = useNavigate();
  

  const error: unknown = useRouteError();
  const errorMessage = setMessage(error);
  const [isLoading, setIsLoading] = useState<boolean>(true);


  /**
   * check error object message and return custom string error
   * @param error 
   */
  function setMessage(error: unknown): string {

    console.error("ErrorPage", error);

    if (axios.isAxiosError(error)) {

      // Requested resource does not exist.
      if (error.response?.data.error === "Resource not found.") {
        return "לא נמצא.";
      }

      // Current user is authenticated but unauthorized for this action.
      if (error.response?.data.error === "Unauthorized") {
        return "אין לך הרשאה מתאימה לגשת למשאב זה.";
      }

    }

    return "מצטערים. התרחשה שגיאה.";
  }

  useEffect(() => {

    if (axios.isAxiosError(error) && error.response?.data.error === "Unauthenticated.") {
    
      async function handleLogOut(){
        await logoutUser();
        navigate("/login");
        toast.error(
          <>
            נותקת עקב חוסר פעילות. <br />
            יש להתחבר מחדש.
          </>,
          { autoClose: 5000, toastId: 'session-expired' }
        );
      }
      
      handleLogOut();
    }

    else{
      setIsLoading(false);
    }
    
  }, []);


  return (
    <StyledErrorPage>
      {!isLoading? <>
        <h1>שגיאה!</h1>
        <p>
          סטטוס קוד: <i>{(error as ErrorResponse).status ?? (error as AxiosError).response?.status}</i>
        </p>
        <p>
          הודעת שגיאה: <i>{(error as ErrorResponse).statusText || (error as Error).message}</i>
        </p>
        <p>
          הודעה מותאמת אישית: <i>{errorMessage}</i>
        </p>
        <button onClick={() => { navigate("/") }}>חזור למסך הראשי</button>
      </> : null}
    </StyledErrorPage>
  );
}

export default ErrorPage